import { useEffect, useMemo, useRef, useState } from 'react';
import ffinUploadCarPhoto from '../../../../api/bank/ffinUploadCarPhoto';
import alert from '../../../../helpers/alert';

// Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð° Freedom (ÐºÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ / Ð±/Ñ Ð°Ð²ÑÐ¾).
// ÐÐ±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ñ 5 ÑÐ°ÐºÑÑÑÐ¾Ð², ÑÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ â Ð¾Ð¿ÑÐ¸Ð¾Ð½Ð°Ð»ÑÐ½Ð¾. Ð¡Ð¾Ð¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ðµ ÑÐ¸Ð¿Ð°Ð¼ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²
// (completed_order_documents_types): 46 Â«Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾Â» (serialNumberId 1..4), 47 Â«Ð¤Ð¾ÑÐ¾ VINÂ»,
// 45 Â«Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑÂ». Backend Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ Ð¸Ñ Ð² Ð±Ð°Ð½Ðº Ð¿ÑÐ¸ Ð²ÑÐ±Ð¾ÑÐµ Freedom (Ð´Ð¾ /confirm).
const SLOTS = [
  { key: 'FRONT_SIDE_IMAGE', label: 'Ð¡Ð¿ÐµÑÐµÐ´Ð¸', typeId: 46, serial: 1, required: true },
  { key: 'LEFT_SIDE_IMAGE', label: 'Ð¡Ð»ÐµÐ²Ð°', typeId: 46, serial: 2, required: true },
  { key: 'RIGHT_SIDE_IMAGE', label: 'Ð¡Ð¿ÑÐ°Ð²Ð°', typeId: 46, serial: 3, required: true },
  { key: 'BACK_SIDE_IMAGE', label: 'Ð¡Ð·Ð°Ð´Ð¸', typeId: 46, serial: 4, required: true },
  { key: 'VIN_IMAGE', label: 'Ð¤Ð¾ÑÐ¾ VIN', typeId: 47, serial: 1, required: true },
  { key: 'TECHNICAL_PASSPORT_FRONT_SIDE_IMAGE', label: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ (Ð½ÐµÐ¾Ð±ÑÐ·.)', typeId: 45, serial: 1, required: false },
];

const CommissionPhotos = ({ appealId, documents, onReadyChange }) => {
  // ÐÐ°ÐºÐ¸Ðµ ÑÐ°ÐºÑÑÑÑ ÑÐ¶Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ñ (Ð¿Ð¾ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ð¼ ÑÐ´ÐµÐ»ÐºÐ¸) â ÑÑÐ¾Ð±Ñ Ð½Ðµ ÑÐµÑÑÑÑ Ð¿ÑÐ¸ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐµ.
  const initialDone = useMemo(() => {
    const done = {};
    (documents || []).forEach((d) => {
      SLOTS.forEach((s) => {
        if (d?.typeId === s.typeId && (d?.serialNumberId ?? 1) === s.serial) {
          done[s.key] = true;
        }
      });
    });
    return done;
  }, [documents]);

  const [done, setDone] = useState(initialDone);
  const [busy, setBusy] = useState(null);
  const inputs = useRef({});

  const requiredKeys = SLOTS.filter((s) => s.required).map((s) => s.key);
  const ready = requiredKeys.every((k) => done[k]);

  useEffect(() => {
    onReadyChange && onReadyChange(ready);
  }, [ready, onReadyChange]);

  const pick = (slot) => inputs.current[slot.key]?.click();

  const onFile = async (slot, e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!appealId) {
      alert.error('ÐÐ°ÑÐ²ÐºÐ° Freedom ÐµÑÑ Ð½Ðµ ÑÐ¾Ð·Ð´Ð°Ð½Ð° â ÑÐ¾ÑÐ¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð½ÐµÐ»ÑÐ·Ñ');
      return;
    }
    setBusy(slot.key);
    try {
      await ffinUploadCarPhoto({ appealId, documentType: slot.key, file });
      setDone((prev) => ({ ...prev, [slot.key]: true }));
      alert.success(`Ð¤Ð¾ÑÐ¾ Â«${slot.label}Â» Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð¾`);
    } catch (err) {
      alert.error(err?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ¾ÑÐ¾');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: 12,
        padding: 16,
        marginBottom: 20,
        background: ready ? '#f2fbf3' : '#fff8f0',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>Ð¤Ð¾ÑÐ¾ Ð°Ð²ÑÐ¾ Ð´Ð»Ñ Ð¾ÑÐµÐ½ÐºÐ¸ Ð·Ð°Ð»Ð¾Ð³Ð° (Freedom)</div>
      <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
        ÐÐ¾Ð¼Ð¸ÑÑÐ¸Ð¾Ð½Ð½Ð¾Ðµ / Ð±/Ñ Ð°Ð²ÑÐ¾: Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÐµ 5 Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½ÑÑ ÑÐ¾ÑÐ¾ Ð´Ð¾ Ð²ÑÐ±Ð¾ÑÐ° Freedom, Ð¸Ð½Ð°ÑÐµ Ð±Ð°Ð½Ðº Ð¾ÑÐºÐ»Ð¾Ð½Ð¸Ñ Ð·Ð°ÑÐ²ÐºÑ.
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {SLOTS.map((slot) => (
          <div
            key={slot.key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              minWidth: 150,
            }}
          >
            <button
              type="button"
              onClick={() => pick(slot)}
              disabled={busy === slot.key}
              style={{
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: 8,
                border: '1px solid #c8c8c8',
                background: done[slot.key] ? '#e3f5e6' : '#fff',
                width: '100%',
                textAlign: 'left',
              }}
            >
              {done[slot.key] ? 'â ' : ''}
              {slot.label}
              {slot.required ? ' *' : ''}
              {busy === slot.key ? ' â¦' : ''}
            </button>
            <input
              ref={(el) => (inputs.current[slot.key] = el)}
              type="file"
              accept="image/png,image/jpeg"
              style={{ display: 'none' }}
              onChange={(e) => onFile(slot, e)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommissionPhotos;
